import React from 'react';

import Layout from '@/components/layout/Index';
import AllNotifications from '@/components/layout/notification/AllNotification';
import { useSelector } from 'react-redux';

import Head from 'next/head';
import LandingLayout from '@/components/landing/home/LandingLayout';
import useWidth from '@/helpers/widthUtil';

const Notification = () => {
  const { isMobile } = useWidth();
  const user = useSelector((state: any) => state?.auth?.creds?.user_data);

  return (
    <>
      {/* {(user?.user_type === 'instructor' && user?.status === 'APPROVE') ||
      user?.user_type === 'staff' ? (
        <Layout>
          <div
            className="d-flex justify-content-center"
            style={{ marginBottom: '100px' }}
          >
            <AllNotifications />
          </div>
        </Layout>
      ) : (
        <> */}
      <Head>
        <title>Notifications | Learnsic</title>
      </Head>
      <LandingLayout>
        <div className="custom-container">
          <div className={`${isMobile ? 'ptb-100' : 'mb-30'}`}>
            <AllNotifications />
          </div>
        </div>
      </LandingLayout>
    </>
    //   )}
    // </>
  );
};

export default Notification;
